import { PreviewPanel } from './PreviewPanel';
import { AudioLibrary } from './AudioLibrary';
import type { PreviewData } from '@/types';
import { useAudioUpload } from '@/hooks/useAudioUpload';

interface SidebarProps {
  activeTab: 'preview' | 'audio';
  preview: PreviewData | null;
  onTabChange: (tab: 'preview' | 'audio') => void;
  onChapterClick?: (chapterIndex: number) => void;
  onChapterEdit?: (chapter: PreviewData['chapters'][number]) => void;
  onInsertAudio: (audioId: string, label: string) => void;
}

export function Sidebar({
  activeTab,
  preview,
  onTabChange,
  onChapterClick,
  onChapterEdit,
  onInsertAudio
}: SidebarProps) {
  const audioUpload = useAudioUpload();

  return (
    <div className="space-y-6">
      {/* Sidebar Tabs */}
      <div className="flex items-center gap-1 border-b border-stone-200">
        <button
          onClick={() => onTabChange('preview')}
          className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
            activeTab === 'preview'
              ? 'border-stone-800 text-stone-800'
              : 'border-transparent text-stone-400 hover:text-stone-600'
          }`}
        >
          Preview
        </button>
        <button
          onClick={() => onTabChange('audio')}
          className={`px-4 py-2 text-sm font-medium border-b-2 transition-colors ${
            activeTab === 'audio'
              ? 'border-stone-800 text-stone-800'
              : 'border-transparent text-stone-400 hover:text-stone-600'
          }`}
        >
          Audio Library
        </button>
      </div>

      {activeTab === 'preview' ? (
        <PreviewPanel 
          preview={preview} 
          onChapterClick={onChapterClick}
          onChapterEdit={onChapterEdit}
        />
      ) : (
        <AudioLibrary
          isDragging={audioUpload.isDragging}
          uploadingIds={audioUpload.uploadingIds}
          audios={audioUpload.recentAudios}
          playingAudio={audioUpload.playingAudio}
          onDragOver={audioUpload.handleDragOver}
          onDragLeave={audioUpload.handleDragLeave}
          onDrop={audioUpload.handleDrop}
          onPlay={audioUpload.playAudio}
          onInsert={onInsertAudio}
        />
      )}
    </div>
  );
}
